// ** React Imports
import React from 'react'

// ** MUI Imports
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'

// ** Third Party Imports
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'

const FormInput = props => {
  // ** Props
  const { name, control, label, placeholder, errors, fullWidth, size, type, InputProps } = props
  return (
    <FormControl fullWidth={fullWidth}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <TextField
            value={value ?? ''}
            size={size || 'medium'}
            label={label}
            type={type}
            onChange={onChange}
            placeholder={placeholder}
            error={Boolean(errors?.[name])}
            InputProps={InputProps}
            aria-describedby={`validation-basic-${name}`}
            InputLabelProps={{
              sx: {
                color: theme => theme.palette.grey[500]
              }
            }}
          />
        )}
      />
      {errors?.[name] && (
        <FormHelperText sx={{ color: 'error.main' }} id={`validation-basic-${name}`}>
          {errors?.[name].message}
        </FormHelperText>
      )}
    </FormControl>
  )
}

FormInput.propTypes = {
  control: PropTypes.func.isRequired, // Required string prop
  errors: PropTypes.func.isRequired, // Optional string prop
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool
}

export default FormInput
